import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { StripePayoutReconciliationReport } from './stripe-payout-reconciliation-report';

export function initStripePayoutReconciliationReport() {
  document.getElementsByName('stripe-payout-reconciliation-report').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <StripePayoutReconciliationReport {...dataset} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
